import { render } from "./WorkAreaDetailsPageSettingsGeneral.vue?vue&type=template&id=2341ae50"
import script from "./WorkAreaDetailsPageSettingsGeneral.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetailsPageSettingsGeneral.vue?vue&type=script&lang=ts"
script.render = render

export default script